import { useSelector } from 'react-redux';
import styled, { css, DefaultTheme } from 'styled-components';
import { selectUserIsAuthenticated } from '@/redux/selectors/user';
import { getButtonCount } from '@/redux/selectors/app';
import { AppState } from '@/redux';

export default styled.div`
  ${({ theme }: { theme: DefaultTheme }) => {
    const isAuth = useSelector(selectUserIsAuthenticated);

    const buttonCount = useSelector<AppState, number>(getButtonCount);

    return css`
      height: 100dvh;
      position: relative;
      .draggable-1,
      .draggable-2,
      .draggable-3,
      .draggable-4,
      .draggable-5,
      .draggable-6 {
        @media ${theme.mq.min.tablet} {
          width: 3.25em;
          height: ${isAuth
            ? buttonCount === 5
              ? '16em'
              : '18.25em'
            : '4.5em'};
          position: absolute;
          border-radius: 0.375em;
        }
      }
      /* Top Vert */
      .draggable-1 {
        @media ${theme.mq.min.tablet} {
          top: 1.5em;
          left: 1.5em;
        }
      }
      .draggable-2 {
        @media ${theme.mq.min.tablet} {
          top: 1.5em;
          right: 1.5em;
        }
      }
      /* Center Left */
      .draggable-3 {
        @media ${theme.mq.min.tablet} {
          top: 50%;
          left: 1.5em;
          transform: translateY(-50%);
        }
      }
      /* Center Right */
      .draggable-4 {
        @media ${theme.mq.min.tablet} {
          top: 50%;
          right: 1.5em;
        }
        transform: translateY(-50%);
      }
      /* Bottom Left */
      .draggable-5 {
        @media ${theme.mq.min.tablet} {
          bottom: 1.5em;
          left: 1.5em;
        }
      }
      /* Bottom Right */
      .draggable-6 {
        @media ${theme.mq.min.tablet} {
          bottom: 1.5em;
          right: 1.5em;
        }
      }
      /* Backgrounds */
      &.draggable-points > div {
        @media ${theme.mq.min.tablet} {
          background: rgba(0, 48, 77, 0.2);
        }
      }
      /* Border */
      .draggable-point--border {
        @media ${theme.mq.min.tablet} {
          border: 0.125em dashed var(--primary-color);
        }
      }

      @media ${({ theme }) => theme.mq.max.tablet} {
        .divider:first-child {
          display: none;
        }
      }
    `;
  }}
`;
